import styled from '@emotion/styled';
import { mq } from '@styles/breakpoints';
import { ThemeProps } from '@theme/base';
import { ExploreResorts } from '@components/explore-resorts';
import { Experiences } from '@components/product/experiences/Experiences';
import { OffersGroup } from '@components/common/offers';
import { TravelGuideGroup } from '@components/guides';
import { VideoGuideGroup } from '@components/guides/VideoGuideGroup';
import { Climate } from '@components/climate';
import { ProductPackageGroup } from '@components/product/product-package/ProductPackageGroup';

export const StyledProductPackageGroup = styled(ProductPackageGroup)(({ theme }: ThemeProps) => ({
  marginBottom: theme.custom.spacing.xxLarge,
  [mq.medium]: {
    marginBottom: theme.custom.spacing.xxxLarge
  }
}));

export const StyledOffersGroup = styled(OffersGroup)(({ theme }: ThemeProps) => ({
  marginBottom: theme.custom.spacing.xxLarge,
  [mq.medium]: {
    marginBottom: theme.custom.spacing.xxxLarge
  }
}));

export const StyledExploreResorts = styled(ExploreResorts)(({ theme }: ThemeProps) => ({
  marginBottom: theme.custom.spacing.xxLarge,
  [mq.medium]: {
    marginBottom: theme.custom.spacing.xxxLarge
  }
}));

export const StyledExperiences = styled(Experiences)(({ theme }: ThemeProps) => ({
  marginBottom: theme.custom.spacing.xxLarge,
  [mq.medium]: {
    marginBottom: theme.custom.spacing.xxxLarge
  }
}));

export const StyledTravelGuides = styled(TravelGuideGroup)(({ theme }: ThemeProps) => ({
  marginBottom: theme.custom.spacing.xxLarge,
  [mq.medium]: {
    marginBottom: theme.custom.spacing.xxxLarge
  }
}));

interface VideoGuideProps extends ThemeProps {
  marginTop?: boolean;
}

export const StyledVideoGuides: any = styled(VideoGuideGroup)(({ theme, marginTop }: VideoGuideProps) => ({
  marginBottom: theme.custom.spacing.xxLarge,
  marginTop: marginTop ? theme.custom.spacing.xxLarge : 0,
  [mq.medium]: {
    marginBottom: theme.custom.spacing.xxxLarge,
    marginTop: marginTop ? theme.custom.spacing.xxxLarge : 0
  }
}));

export const StyledClimate = styled(Climate)(({ theme }: ThemeProps) => ({
  marginBottom: theme.custom.spacing.xxLarge,
  [mq.medium]: {
    marginBottom: theme.custom.spacing.xxxLarge
  }
}));

export const CMSComponentsContainer = styled.div({
  ['[data-testid="mh-benefits-row"]']: {
    marginBottom: 0
  }
});
